import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import VisibilitySensor from "react-visibility-sensor";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Navigation, Autoplay } from "swiper/modules";

import arrowLeft from "../../../../assets/img/components/arrow-left.webp";
import arrowRight from "../../../../assets/img/components/arrow-right.webp";
import img1 from "../../../assets/img/landingPageOne/sectionFive/img1.webp";
import img2 from "../../../assets/img/landingPageOne/sectionFive/img2.webp";
import img3 from "../../../assets/img/landingPageOne/sectionFive/img3.webp";

import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';

const DATA = [
  {
    id: 1,
    class: "card1",
    img: img1,
    titleKey: "lp1_intermodal1_title",
    textKey: "lp1_intermodal1_text",
    text2Key: null,
  },
  {
    id: 2,
    class: "card2",
    img: img2,
    titleKey: "lp1_intermodal2_title",
    textKey: "lp1_intermodal2_text",
    text2Key: null,
  },
  {
    id: 3,
    class: "card3",
    img: img3,
    titleKey: "lp1_intermodal3_title",
    textKey: "lp1_intermodal3_text",
    text2Key: null,
  },
];

function SectionFive() {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={400}>
      <div id="fleet" className={`sectionFive ${isVisible ? "visible" : ""}`}>
        <div className="sectionFiveTitle">
          <h1 className={`${isVisible ? "visible" : ""}`}>
            {t("lp1_fleet_title")} <span> {t("lp1_fleet_title_span")}</span>
          </h1>
          <p>
            {t("lp1_fleet_text")}
          </p>
        </div>
        <Swiper
          className={`${isVisible ? "visible" : ""}`}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          effect={'fade'}
          modules={[Navigation, EffectFade, Autoplay]}
          speed={800}
          slidesPerView={"1"}
          spaceBetween={200}
          loop={true}
        >
          <div className={`swiper-button-prev`}>
            <img src={arrowLeft} width={"40px"} alt="" />
          </div>
          {DATA.map((item) => (
            <SwiperSlide key={item.id}>
              <div className={`card ${item.class}`}>
                <div className="cardText">
                  <h1 className={`${isVisible ? "visible" : ""}`}>
                    {t(item.titleKey)}
                  </h1>
                  <p className={`text1 ${isVisible ? "visible" : ""}`}>
                    {t(item.textKey)}
                  </p>
                  {item.text2Key && (
                    <p className={`text1 ${isVisible ? "visible" : ""}`}>
                      {t(item.text2Key)}
                    </p>
                  )}
                </div>
                <img className={`${isVisible ? "visible" : ""}`} src={item.img} alt="" />
              </div>
            </SwiperSlide>
          ))}
          <div className={`swiper-button-next`}>
            <img src={arrowRight} width={"40px"} alt="" />
          </div>
        </Swiper>
      </div>
    </VisibilitySensor>
  );
}
export default SectionFive;
